import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取相关商品列表
   */
  getList(filter: string, pageSize: number, currentPage: number) {
    let params = {
      Filter: filter,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    return Ajax.get(`/api/productManagement/relatedProduct/GetList`, {
      params: params,
    })
  },
  /**
   * 获取商品列表
   */
  getRelatedProduct(id: string) {
    return Ajax.get(`/api/productManagement/relatedProduct?id=${id}`)
  },
  /**
   * 删除推荐商品
   * @param id
   */
  deleteRelatedProduct(id: string) {
    return Ajax.delete(`/api/productManagement/relatedProduct?id=${id}`)
  },
  /**
   * 更新相关商品
   * @param id
   * @param data
   */
  updateRelatedProduct(id: string, data: any) {
    return Ajax.put(`/api/productManagement/relatedProduct/${id}`, data)
  },
  /**
   * 添加相关商品商品
   * @param data
   */
  create(data: any) {
    return Ajax.post(`/api/productManagement/relatedProduct`, data)
  },
  /**
   * 导出相关商品
   */
  exportRelatePorduct() {
    return Ajax.get(`/api/productManagement/relatedProduct/ExportRelatedProductsFile`, { responseType: "blob" })
  },
  /**
   * 导出item里面的相关商品
   */
  exportItemRelateProduct(id: string) {
    return Ajax.get(`/api/productManagement/relatedProduct/ExportFile/${id}`, { responseType: "blob" })
  }
}
